import styled from "@emotion/styled";
import { FC } from "react";
import { useSelector } from "react-redux";

import { Error } from "@livechat/design-system-icons";
import { Avatar, DesignToken, Icon, Tag } from "@livechat/design-system-react-components";

import { selectTeams, selectTeamsAlphabetically } from "store/entities/teams";
import { withVar } from "themes/helpers";

import { validTeam } from "../validators";

interface IProps {
  teamID?: string;
}

export const AccordionTeamTag: FC<IProps> = ({ teamID }) => {
  const teamsById = useSelector(selectTeams);
  const allTeams = useSelector(selectTeamsAlphabetically);

  const invalidTeam = !teamID || validTeam(teamID, allTeams);

  const team = teamID ? teamsById[teamID] : undefined;

  return (
    <TeamTag
      kind={invalidTeam ? "error" : "default"}
      leftNode={
        invalidTeam ? (
          <Icon source={Error} customColor={withVar(DesignToken.ActionNegativeDefault)} />
        ) : (
          <Avatar type="text" size="xxxsmall" text={team?.name} shape="rounded-square" />
        )
      }
    >
      {invalidTeam ? "Select team…" : team?.name}
    </TeamTag>
  );
};

const TeamTag = styled(Tag)`
  max-width: 200px;
`;
